// Where the logo / background-clip uploaders POST for a signed URL.
//
// The internal onboarding form is authenticated and hits the @Roles-guarded
// station routes. The publisher-facing intake is unauthenticated and hits the
// token-scoped mirrors, which additionally namespace every object under
// `intake/<intakeId>/`. Threading this through as config keeps one uploader
// component instead of two near-identical ones.

export interface UploadEndpoints {
  logoUploadUrlPath: string;
  clipUploadUrlPath: string;
  /** Present on the intake variant — the token is in the path, so send no JWT. */
  anonymous?: boolean;
}

export const ADMIN_UPLOAD_ENDPOINTS: UploadEndpoints = {
  logoUploadUrlPath: '/stations/logo/upload-url',
  clipUploadUrlPath: '/stations/background-clip/upload-url',
};

export function intakeUploadEndpoints(token: string): UploadEndpoints {
  const base = `/publisher-intake/token/${encodeURIComponent(token)}`;
  return {
    logoUploadUrlPath: `${base}/logo-upload-url`,
    clipUploadUrlPath: `${base}/clip-upload-url`,
    anonymous: true,
  };
}
